module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":"Google system could not validate that you are not an automated request. Please refresh the page and try again. If problem persists, please try again with a different browser or a different device."}}')
  delete Component.options._Ctor
}
